// extracted by mini-css-extract-plugin
export default {"active":"Navigation_active__fFvX2","inactive":"Navigation_inactive__5mLsT","nav":"Navigation_nav__sea3L"};